import axios from "../../components/shared/axios"
import { actions } from "../templates";

const fetchTemplates = async (state, dispatch) => {
  const [libraryResponse, teamResponse] = await Promise.all([
    axios.get(`${state.basename}/library.json`),
    axios.get(`${state.basename}/team.json`),
  ])

  const teamData = {}

  teamResponse.data.team_templates.data.forEach((template) => {
    teamData[template.attributes.dropbox_template_id] = template.attributes
  })

  const templates = libraryResponse.data.templates.data.map((template) => ({
    ...template,
    attributes: {
      ...teamData[template.attributes.dropbox_template_id],
      ...template.attributes,
    },
  }))

  dispatch({
    type: actions.SET_TEMPLATES,
    templates: templates,
    templateCategories: libraryResponse.data.template_categories.data,
  })
}

export { fetchTemplates }
